// extracted by mini-css-extract-plugin
export default {"btnPos":"StripeConfigUnit_btnPos__ZefeF","scrollFor":"StripeConfigUnit_scrollFor__bKbad"};